import { render, staticRenderFns } from "./CreateNoteAsset.vue?vue&type=template&id=066fe0b1"
import script from "./CreateNoteAsset.vue?vue&type=script&lang=js"
export * from "./CreateNoteAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports